<template>
  <div class="view-container">
    <div v-if="branch" class="center">
      <h2>{{ branch.name }}</h2>
      <div class="contact-details-container col-md-12">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 left">
          <span style="display: block">
            {{ branch.address }}
          </span>
          <span style="display: block">
            {{ branch.province }}
          </span>
          <span style="display: block">
            {{ branch.areaCode }}
          </span>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 right">
          <span style="display: block">
            {{ branch.contactNo }}
          </span>
          <span style="display: block">
            {{ branch.emailAddress }}
          </span>
        </div>
      </div>
      <hr />
    </div>
    <div class="text-container col-md-6 col-sm-12">
      <router-link to="/Menu">
        <button v-if="$tableNo" class="btn col-md-8 col-sm-8 col-xs-8 selected">
          <h3>Place Order<br />for<br />Table {{ $tableNo }}</h3>
        </button>
        <button
          v-else-if="$isTab"
          class="btn col-md-8 col-sm-8 col-xs-8 selected"
        >
          <h3>Place Order<br />on<br />Tab</h3>
        </button>
      </router-link>
      <router-link to="/QRCScanner">
        <button
          :class=" !$tableNo && !$isTab
              ? 'btn col-md-8 col-sm-8 col-xs-8 selected'
              : 'btn col-md-8 col-sm-8 col-xs-8'
          "
        >
          <h3>Scan Table<br />QR Code</h3>
        </button>
      </router-link>
      <router-link :to="{ path: '/Menu', query: { clear: true } }">
        <button class="btn col-md-8 col-sm-8 col-xs-8 clearTab">
          <h3>Place Order<br />for<br />Pickup or Delivery</h3>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Seating",
  data() {
    return {
      branch: null,
    };
  },
  methods: {},
  created() {
    var _self = this;

    if (!this.$franchiseID) this.$router.push({ path: "Franchise" });

    var paymentData = {
      FranchiseID: _self.$franchiseID,
      BranchID: _self.$branchID,
    };
    _self.$ooApi.orders.branches.get.v1(paymentData).then(function (response) {
      _self.branch = response.data;
    });
  },
};
</script>
<style scoped>
.contact-details-container {
  display: inline-flex;
}
.text-container {
  text-align: center;
  margin: auto;
}
.text-container .btn {
  margin-bottom: 15px !important;
  min-width: 265px;
  border: 1px solid black !important;
  background-color: white;
}
.text-container .btn.selected {
  border: none !important;
  background-color: #1766e6;
  color: #ffffff;
}
/* @media (max-width: 767px) {
  .text-container {
    margin-top: 65px;
    padding-bottom: 65px;
  }
} */
</style>